/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

/* Une categorie de modeles ( `console/design-category/*` de l'API ). Le type se
   dit par son NOM a l'ecriture ( « web », « pop-up »… ) et par son identifiant a
   la lecture et au filtre ( `type=3` ). */
export interface DesignType {
    Id: number;
    ApiName: string;
}

/* Les types dont la bibliotheque du logiciel range les modeles, dans l'ordre du
   volet ( `src/App/UseCases/Content/Categories/Data.ts` du desktop ). */
export const DesignTypes: DesignType[] = [
    { Id: 3, ApiName: "web" },
    { Id: 6, ApiName: "section" },
    { Id: 5, ApiName: "pop-up" },
    { Id: 4, ApiName: "email" },
    { Id: 2, ApiName: "pdf" }
];

/* Les langues du logiciel ; le francais est la langue par defaut de l'API. */
export const DesignCategoryLocales: string[] = [ "fr", "en", "de", "es", "it", "nl", "pt" ];

export interface DesignCategory {
    Id: number;
    Name: string;
    TypeId: number;
    TypeName: string;
    Translations: { [ locale: string ]: string };
    Order: number | null;
}

export interface DesignCategoryRequest {
    TypeId: number;
    Order: number | null;
    Translations: { [ locale: string ]: string };
}
